import { TMarketArea } from "features/MarketAreas/types";
import { apiClient } from "lib/apiClient";

export interface IEditMarketArea {
  name?: TMarketArea["name"];
  description?: TMarketArea["description"];
}

export const editMarketAreaById = async (
  id: string,
  request: IEditMarketArea
): Promise<TMarketArea> => {
  const response = await apiClient.patch<TMarketArea>(
    `/market-areas/${id}`,
    request
  );

  return response.data;
};
